<template>
    <Loading v-bind:show="showLoading">
        <PageTitle title="Perfil do Aluno" />
        <md-dialog :md-active.sync="showEditAluno">

            <Loading v-bind:show="showModalLoading" style="min-height: 100px; margin-top: 38px">
                <md-dialog-title>Dados Aluno</md-dialog-title>
                <md-content>
                    <form novalidate class="md-layout">
                        <md-card class="md-layout-item md-size-100 md-small-size-100">
                            <md-card-content>
                                <md-field>

                                    <label for="email"><md-icon>mail</md-icon> Email</label>
                                    <md-input type="email" name="email" id="email" autocomplete="email" v-model="form.email" />
                                </md-field>

                                <div class="md-layout-item">
                                    <div class="md-layout md-gutter">

                                        <span class="md-layout-item md-size-100">
                                            <md-icon>phone</md-icon>
                                            Telefones:
                                            <md-button class="md-icon-button md-primary" @click="form.telefones.push('')" v-show="form.telefones.length < 4">
                                                <md-icon>add</md-icon>
                                            </md-button>
                                        </span>
                                        <div class="md-layout-item md-size-50 md-small-size-50" v-for="(item,index) in form.telefones" v-bind:key="index">
                                            <md-field>

                                                <label :for="'telefone' + index"></label>
                                                <md-input type="tel" :name="'form.telefone' + index" :id="'form.telefone' + index" v-model="form.telefones[index]" maxlength="14" v-mask="['(##)#####-####', '(##)####-####']" />
                                                <md-button class="md-primary" @click="form.telefones.splice(index,1)">-</md-button>
                                            </md-field>
                                        </div>
                                    </div>
                                </div>
                            </md-card-content>

                            <md-card-actions>
                                <md-button class="md-primary" @click="showEditAluno = false">Cancelar</md-button>
                                <md-button class="md-primary" @click="salvarDadosAluno()">Salvar</md-button>
                            </md-card-actions>
                        </md-card>
                    </form>
                </md-content>
            </Loading>
        </md-dialog>

        <md-toolbar id="md-toolbar-page" md-elevation="0" class="md-dense" style="background-color: inherit">
            <h3 class="md-title" style="flex: 1"></h3>
            <md-button class="md-text-and-icon md-outlined md-primary md-dense" @click="showEditAluno = true">
                <md-icon>edit</md-icon>Editar
            </md-button>
        </md-toolbar>

        <div v-if="dadosAba" class="md-layout">
            <div class="md-layout-item md-size-50">
                <md-list class="md-double-line md-dense">
                    <md-list-item>
                        <md-icon>face</md-icon>
                        <div class="md-list-item-text">
                            <span class="s-h4">{{dadosAba.nomeAluno}}</span>
                            <span class="s-h3 regular">Nome Completo</span>
                        </div>
                    </md-list-item>

                    <md-list-item>
                        <md-icon>recent_actors</md-icon>
                        <div class="md-list-item-text">
                            <span class="s-h4">{{dadosAba.cpf}}</span>
                            <span class="s-h3 regular">CPF</span>
                        </div>
                    </md-list-item>

                    <md-list-item>
                        <md-icon>assignment_ind</md-icon>
                        <div class="md-list-item-text">
                            <span class="s-h4">{{dadosAba.codigoAluno}}{{dadosAba.codigoEspecialidade}}</span>
                            <span class="s-h3 regular">RA</span>
                        </div>
                    </md-list-item>

                    <md-list-item>
                        <md-icon>email</md-icon>
                        <div class="md-list-item-text">
                            <span class="s-h4">{{dadosAba.email}}</span>
                            <span class="s-h3 regular">E-mail</span>
                        </div>
                    </md-list-item>

                    <md-list-item>
                        <md-icon>local_phone</md-icon>
                        <div class="md-list-item-text">
                            <span class="s-h4">
                                {{telefonesInLine}}
                            </span>
                            <span class="s-h3 regular">Telefone</span>
                        </div>
                    </md-list-item>
                </md-list>
            </div>

            <div class="md-layout-item md-size-50">
                <md-list class="md-double-line md-dense">

                    <md-list-item>
                        <md-icon>menu_book</md-icon>
                        <div class="md-list-item-text">
                            <span class="s-h4">{{dadosAba.codigoEspecialidade}} - {{dadosAba.descricaoEspecialidade}}</span>
                            <span class="s-h3 regular">Curso</span>
                        </div>
                    </md-list-item>

                    <md-list-item>
                        <md-icon>school</md-icon>
                        <div class="md-list-item-text">
                            <span class="s-h4">{{dadosAba.codigoTurma}} - NFT:{{dadosAba.situacaoNftTurma}} - {{dadosAba.etapaAtualTurma}}º Semestre </span>
                            <span class="s-h3 regular">Turma</span>
                        </div>
                    </md-list-item>

                    <md-list-item>
                        <md-icon>account_balance</md-icon>
                        <div class="md-list-item-text">
                            <span class="s-h4">{{dadosAba.codigoEmpresa}} - {{dadosAba.nomeEmpresa}} - {{dadosAba.iunicidade}}/{{dadosAba.iuniuf}} - {{dadosAba.nomeCampus}}</span>
                            <span class="s-h3 regular">Unidade</span>
                        </div>
                    </md-list-item>

                    <md-list-item>
                        <md-icon>event</md-icon>
                        <div class="md-list-item-text">
                            <span class="s-h4" v-formatdate="dadosAba.dataNascimento"></span>
                            <span class="s-h3 regular">Data de Nascimento</span>
                        </div>
                    </md-list-item>

                    <md-list-item>
                        <md-icon>location_on</md-icon>
                        <div class="md-list-item-text">
                            <span class="s-h4">{{dadosAba.endereco}}</span>
                            <span class="s-h3 regular">Endereço</span>
                        </div>
                    </md-list-item>

                    <md-list-item class="triple-line">
                        <md-icon>people_alt</md-icon>
                        <div class="md-list-item-text">
                            <span class="s-h4">Mãe: {{dadosAba.nomeMae}}</span>
                            <span class="s-h4">Pai: {{dadosAba.nomePai}}</span>
                            <span class="s-h3 regular">Filiação</span>
                        </div>
                    </md-list-item>
                </md-list>
            </div>
        </div>
        <hr />
        <TimeLineComponente v-bind:dadosTimeLine="dadosTimeLine" v-if="$featureToggle && $featureToggle.INTEGRA_TIMELINE_EVENTOS" />
    </Loading>
</template>

<script>
    import { mask } from 'vue-the-mask'; //https://vuejs-tips.github.io/vue-the-mask/
    import Loading from '@/components/Loading';
    import PageTitle from '@/components/PageTitle';
    import TimeLineComponente from '@/components/TimeLine';
    import { formatdate } from '@/directives/formatdate.js';
    import PerfilAluno from '@/services/PerfilAlunoService.js';
    import MatriculaService from '@/services/MatriculaService.js';
    import TimeLineSevice from '@/services/TimeLineService.js';



    export default {
        name: 'PerfilAluno',
        components: {
            Loading,
            PageTitle,
            TimeLineComponente
        },
        data() {
            return {
                dadosAba: null,
                dadosTimeLine: [],
                showLoading: false,
                showModalLoading: false,
                showEditAluno: false,
                form: {
                    email: "",
                    telefones: []
                }
            }
        },
        directives: {
            formatdate,
            mask
        },

        created() {
            this.perfilAlunoService = new PerfilAluno(this);
            this.matriculaService = new MatriculaService(this);
            this.timeLineSevice = new TimeLineSevice(this);


            //Verifica se tem aluno selecionado
            if (!sessionStorage.Aluno) {
                this.$router.push('home');
            }
            else {
                let aluno = JSON.parse(sessionStorage.Aluno);
                if (aluno.PerfilAluno) {
                    this.dadosAba = aluno.PerfilAluno;
                    let codigoTimeLine = "OLIMPO-" + this.dadosAba.codigoEmpresa + "-" + this.dadosAba.codigoAluno + "-" + this.dadosAba.codigoEspecialidade;
                    this.CarregaDadosTimeLine(codigoTimeLine);
                }
                else
                    this.$router.push('home');
            }

            //Preperação dos dados de edição
            this.preparaDadosEdicao()
        },

        computed: {
            telefonesInLine() {
                let arrTelefones = [];

                if (this.dadosAba.telefone.replace(/^\s+/, '').replace(/\s+$/, '')) arrTelefones.push(this.dadosAba.telefone);
                if (this.dadosAba.telefone2.replace(/^\s+/, '').replace(/\s+$/, '')) arrTelefones.push(this.dadosAba.telefone2);
                if (this.dadosAba.telefone3.replace(/^\s+/, '').replace(/\s+$/, '')) arrTelefones.push(this.dadosAba.telefone3);
                if (this.dadosAba.telefone4.replace(/^\s+/, '').replace(/\s+$/, '')) arrTelefones.push(this.dadosAba.telefone4);

                return arrTelefones.join(' / ');
            }
        },
        watch: {
            showEditAluno(visible) {
                if (visible) {
                    this.preparaDadosEdicao()
                }
            }
        },
        methods: {
            preparaDadosEdicao() {
                if (this.dadosAba) {
                    this.form = {                 
                            email: "",
                            telefones: []
                        };
                    if (this.dadosAba.telefone.replace(/^\s+/, '').replace(/\s+$/, '')) this.form.telefones.push(this.dadosAba.telefone);
                    if (this.dadosAba.telefone2.replace(/^\s+/, '').replace(/\s+$/, '')) this.form.telefones.push(this.dadosAba.telefone2);
                    if (this.dadosAba.telefone3.replace(/^\s+/, '').replace(/\s+$/, '')) this.form.telefones.push(this.dadosAba.telefone3);
                    if (this.dadosAba.telefone4.replace(/^\s+/, '').replace(/\s+$/, '')) this.form.telefones.push(this.dadosAba.telefone4);

                    this.form.email = this.dadosAba.email;
                }
            },
            salvarDadosAluno() {
                this.showModalLoading = true;
                this.perfilAlunoService.AtualizaAlunoCadastro({
                    codigoAluno: this.dadosAba.codigoAluno,
                    cpf: this.dadosAba.cpf,
                    email: this.form.email,
                    telefone1: this.form.telefones[0] ? this.form.telefones[0] : " ",
                    telefone2: this.form.telefones[1] ? this.form.telefones[1] : " ",
                    telefone3: this.form.telefones[2] ? this.form.telefones[2] : " ",
                    telefone4: this.form.telefones[3] ? this.form.telefones[3] : " "
                }).then(
                    data => {
                        if (data.ok) {
                            this.$modal.info(data.mensagem);
                            this.showEditAluno = false;
                            this.perfilAlunoService.RetornaDadosAluno({ CodigoAluno: this.dadosAba.codigoAluno, codigoEspecialidade: this.dadosAba.codigoEspecialidade }).then(
                                data => {
                                    if (data.ok) {

                                        if (data.dados) {
                                            this.dadosAba = data.dados;
                                            sessionStorage.Aluno = JSON.stringify(this.dadosAba);
                                        }
                                        else
                                            this.$modal.alert("A api de alunos não retornou os dados do ra " + this.dadosAba.codigoAluno + '' + this.dadosAba.codigoEspecialidade + '.');

                                        this.showLoading = false;
                                    }
                                    else {
                                        this.showLoading = false;
                                        this.$modal.info(data.Mensagem);
                                    }
                                },
                                error => {
                                    this.showLoading = false;
                                    if (error.status != 500)
                                        this.$modal.alert((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                                    else
                                        this.$modal.error((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                                })
                        }
                        else {
                            this.$modal.alert(data.mensagem);
                        }
                    },
                    error => {
                        this.$modal.error('Ocorreu um erro ao tentar salvar os dados.', (error.body?.Mensagem || error?.response?.statusText || error.message));
                    }).finally(() => {
                        this.showModalLoading = false;
                        this.showLoading = false;
                    });
            },

            CarregaDadosTimeLine(codigoTimeLine) {
                if (this.$featureToggle.INTEGRA_TIMELINE_EVENTOS) {
                    this.showLoading = true;
                    this.timeLineSevice.ListarEventos({
                        Tipo: "aluno-olimpo",
                        Codigo: codigoTimeLine
                    }).then(
                        data => {
                            this.dadosTimeLine = data;
                        },
                        error => {
                            if (error.status != 500)
                                this.$modal.alert((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                            else
                                this.$modal.error((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                        }).finally(() => {
                            this.showLoading = false;
                        });
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .triple-line .md-list-item-text :nth-child(2) {
        color: rgba(0,0,0,0.87) !important;
    }

    .triple-line .md-list-item-text :nth-child(3) {
        color: var(--md-theme-default-text-accent-on-background, rgba(0,0,0,0.54)) !important;
    }

    .md-dialog {
        width: 50%;
        left: 25%;
    }
</style>
